import m from './module';

import simpleDateField from './dateField/dateField.component';
import simpleDateTimeField from './dateTimeField/dateTimeField.component';
import simpleDisplayTextField from './displayTextField/displayTextField.component';
import simpleDocumentUploadField from './documentUploadField/documentUploadField.component';
import simpleDurationField from './durationField/durationField.component';
import simpleMoneyField from './moneyField/moneyField.component';
import simpleMultiSelectCheckboxField from './multiSelectCheckboxField/multiSelectCheckboxField.component';
import simpleNumericField from './numericField/numericField.component';
import simpleRadioField from './radioField/radioField.component';
import simpleSelectField from './selectField/selectField.component';
import simpleTextAreaField from './textAreaField/textAreaField.component';
import simpleTextField from './textField/textField.component';
import simpleTimeField from './timeField/timeField.component';
import simpleSubSectionField from './subsectionField/subsectionField.component';
import simpleYesNoField from './yesNoField/yesNoField.component';
import simpleHyperlinkField from './hyperlinkField/hyperlinkField.component';
import simplePhonenumberField from './phoneField/phoneField.component';

export const components = {
  simpleDateField,
  simpleDateTimeField,
  simpleDurationField,
  simpleDocumentUploadField,
  simpleMoneyField,
  simpleMultiSelectCheckboxField,
  simpleNumericField,
  simpleRadioField,
  simpleSelectField,
  simpleTextAreaField,
  simpleTextField,
  simpleTimeField,
  simpleSubSectionField,
  simpleYesNoField,
  simpleHyperlinkField,
  simplePhonenumberField,
};

export const componentMap = {
  'FIELD_YES_NO': 'simpleYesNoField',
  'FIELD_MULTISELECT': 'simpleMultiSelectCheckboxField',
  'FIELD_IMAGE_UPLOAD': 'simpleFileUploadField',
  'FIELD_MONEY': 'simpleMoneyField',
  'FIELD_DATE': 'simpleDateField',
  'FIELD_DATETIME': 'simpleDateTimeField',
  // 'FIELD_SELECT': 'selectField',
  'FIELD_DISPLAY_TEXT': 'simpleDisplayTextField',
  'FIELD_SELECT': 'simpleRadioField',
  'FIELD_SELECT_RADIO': 'simpleRadioField',
  'FIELD_TEXTAREA': 'simpleTextAreaField',
  'FIELD_TIME': 'simpleTimeField',
  'FIELD_SIGNATURE_CAPTURE': 'simpleSignatureField',
  'FIELD_AGREEMENT_CHECKBOX': 'simpleAgreementCheckboxField',
  'FIELD_DURATION': 'simpleDurationField',
  'FIELD_FLOAT1': 'simpleNumericField',
  'FIELD_FLOAT2': 'simpleNumericField',
  'FIELD_INTEGER': 'simpleNumericField',
  'FIELD_SUBSECTION': 'simpleSubsectionField',
  'FIELD_DOCUMENT_UPLOAD': 'simpleDocumentUploadField',
  'FIELD_HYPERLINK': 'simpleHyperlinkField',
  'FIELD_PHONENUMBER': 'simplePhonenumberField',
  'default': 'simpleTextField',
};

export default function componentNameForFieldType(fieldType) {
  let componentName = componentMap[fieldType] || componentMap.default;
  return componentName;
};

for (let componentName of Object.keys(components)) {
  m.component(componentName, components[componentName]);
}
